<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <form class="search-box position-relative" @submit.prevent="rechercher">
            
            <div class="col-md-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                    Date
                </label>
                <Field name="dateDebut" type="date"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateVente" class="text-danger"/>
                </div>
            </div>
        </form>
        <div class="d-sm-flex align-items-center">
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  date
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  client
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  montant
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  montant sans epargne
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vente, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{  format_date(vente.dateVente) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.client.prenoms+ ' ' + vente.client.nom }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (vente.montant)? vente.montantSansEpargne : '-' }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <!-- <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="fetchPdfUrl(vente.url)"
                      >
                        <i
                          class="flaticon-delete lh-1 me-8 position-relative top-1" 
                        ></i>
                        Voir la fiche
                      </a>
                    </li> -->
                    
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, onMounted } from 'vue';
  import { paginationFields } from '../Utilities/paginationFields';
  import { error, suppression, format_date } from '../../utils/utils';
  import { Field } from 'vee-validate';
  import ApiService from "../../services/ApiService";
  import  { Vente }  from '../../models/Vente';
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
import { date } from 'yup';
  
  export default defineComponent({
    name: "PointJournalierDesVentes",
    components: {
      PaginationComponent,
      Field
    },
    setup: () => {
  
      const elements = ref<Array<Vente>>([])
      const selectedItem = ref(0);
      const element = ref<Vente>();
      const dateDebut = ref('');
      const dateFin = ref('');
      const today = new Date();
      
      
  
      // BEGIN PAGINATE
      const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);
  
        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE
    
  
      const recharger = () => {
        getAll();
      };
  
      onMounted(() => {
        
        const startOfDay = new Date(today.setHours(0, 0, 0, 0));
        const endOfDay = new Date(today.setHours(23, 59, 59, 999));
        dateDebut.value = `${startOfDay.getFullYear()}-${String(startOfDay.getMonth() + 1).padStart(2, '0')}-${String(startOfDay.getDate()).padStart(2, '0')}T00:00:00`;
        dateFin.value = `${endOfDay.getFullYear()}-${String(endOfDay.getMonth() + 1).padStart(2, '0')}-${String(endOfDay.getDate()).padStart(2, '0')}T23:59:59`;
        console.log(dateDebut.value);
        getAll();
      })
  
      function fetchPdfUrl(url) {
        window.open(url, '_blank');
      }
  
      function getAll(page = 1, limi = 10, searchTerm = '') {

        return ApiService.get(`ventes?page=${page}&limit=${limi}&mot=${searchTerm}&dateDebut=${dateDebut.value}&dateFin=${dateFin.value}&`)
        .then(({ data }) => {
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          // console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      const getCurrentDate = () => {
             const today = new Date();
             const day = String(today.getDate()).padStart(2, '0');
             const month = String(today.getMonth() + 1).padStart(2, '0');
             const year = today.getFullYear();
             return `${year}-${month}-${day}`;
        }
  
      return { 
        getAll,
        suppression,
        elements,
        recharger,
        selectedItem,
        format_date,
        fetchPdfUrl,
        dateDebut,
        dateFin,
        getCurrentDate,
  
        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher
      };
    }
  
  });
  
  </script>